exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".watch-tutorial {\n    margin-bottom: 10px;\n}\n.watch-tutorial .btn {\n    height: unset;\n    font-size: 12px;\n    -webkit-box-shadow: none;\n            box-shadow: none;\n    padding: 4px 8px;\n    line-height: unset;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/login.theprintlife.com/src/app/mnt-master/watch-tutorial/watch-tutorial.component.css
// module id = ../../../../../src/app/mnt-master/watch-tutorial/watch-tutorial.component.css
// module chunks = main